import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-beige to-warm-white py-16 px-6" data-id="element-52">
      <div className="max-w-2xl mx-auto text-center" data-id="element-53">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-dark-text leading-tight mb-8" data-id="element-54">
          Controlá el tiempo de pantallas de tu hijo sin peleas ni castigos
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mb-10" data-id="element-55">
          {/* Golden glow effect */}
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full scale-75" data-id="element-56" />

          <img src="https://cdn.magicpatterns.com/uploads/rofnSfLeAYWvP6r1FG15eF/ChatGPT_Image_26_ene_2026,_19_32_34.png" alt="Ebook 30 Días Sin Pantallas - Guía para padres" className="relative mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto drop-shadow-2xl" data-id="element-57" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        ease: 'easeOut'
      }} className="font-lato text-lg md:text-xl text-medium-text leading-relaxed max-w-xl mx-auto" data-id="element-58">
          Ayudá a tu hijo a reducir el uso del celular y las pantallas,
          recuperar la atención y la calma en casa en menos de 30 días, incluso
          si hoy está totalmente enganchado.
        </motion.p>

        <motion.a href="#seccion-conciencia" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.6
      }} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-block mt-10 bg-red-cta text-white font-lato font-semibold text-base md:text-lg px-8 py-4 rounded-lg shadow-lg hover:bg-red-700 transition-colors duration-200" data-id="element-59">
          QUIERO RECUPERAR A MI HIJO
        </motion.a>
      </div>
    </section>;
}